<template>
    <div style="margin: 20px; text-align: left;">
        <h3 style="text-align: left; margin-left:20px">
            插件管理
        </h3>
        <div style="text-align: right;">
            <el-button @click="showAdd" type="primary">添加</el-button>
        </div>
        <div style="margin-top: 20px;">
            <el-table :data="tableData" border style="width: 100%">
                <el-table-column prop="id" width="80" label="编号" />
                <el-table-column prop="version" width="150" label="版本" />
                <el-table-column prop="status" width="80" label="状态">
                    <template #default="scope">
                        <el-switch :active-value=1 :inactive-value=0 :model-value="scope.row.status"
                            @change="changeStatus(scope.row)"></el-switch>


                    </template>
                </el-table-column>
                <el-table-column prop="file_name" label="文件" />
                <el-table-column prop="desc" label="描述" />
                <el-table-column label="操作" fixed="right" width="120">
                    <template #default="scope">
                        <el-popconfirm title="确认删除吗？" @confirm="itemDelete(scope.row)">
                            <template #reference>
                                <el-button link type="danger">删除</el-button>
                            </template>
                        </el-popconfirm>
                    </template>
                </el-table-column>
            </el-table>
        </div>
    </div>
    <PaginationBar :totalRecords="totalRecords" :currentPage="currentPage" :pageSize="pageSize"
        @page-change="handlePageChange" @page-size-change="handlePageSizeChange" />
    <el-dialog style="text-align:left" v-model="addVisiable" title="新增" width="500" :before-close="handleClose">
        <el-form label-position='top' ref="addFormRef" :rules="formRules" :model="addForm">
            <el-form-item label='版本' prop="version">
                <el-input v-model="addForm.version"></el-input>
            </el-form-item>
            <el-form-item label='描述' prop="desc">
                <el-input type="textarea" rows="6" v-model="addForm.desc"></el-input>
            </el-form-item>
            <el-form-item label='普通' prop="file">
                <el-upload ref="uploadRef" :action="uploadUrl" :headers="uploadHeader" :on-success="uploadSuccess"
                    :on-remove="handleFileRemove">
                    <el-button type="default"><el-icon class="el-icon--right">
                            <Upload />
                        </el-icon>上传文件</el-button>
                </el-upload>
            </el-form-item>
            <el-form-item label='特别' prop="green_file">
                <el-upload ref="uploadGreenRef" :action="uploadUrl" :headers="uploadHeader" :on-success="uploadGreenSuccess"
                    :on-remove="handleGreenFileRemove">
                    <el-button type="default"><el-icon class="el-icon--right">
                            <Upload />
                        </el-icon>上传文件</el-button>
                </el-upload>
            </el-form-item>
            <el-form-item label='排除组织' prop="exclude_organization_ids">
                <el-tree-select v-model="addForm.exclude_organization_ids" :data="organizationOptions"
                               :props="{ label: 'label', children: 'children' }" show-checkbox default-expand-all
                               multiple
                               placeholder="请选择要排除的组织"
                               :render-after-expand="false" clearable style="width: 100%;" filterable check-strictly
                               check-on-click-node/>
            </el-form-item>
        </el-form>
        <template #footer>
            <div class="dialog-footer">
                <el-button @click="handleClose">取消</el-button>
                <el-button type="primary" @click="add(addFormRef)">
                    添加
                </el-button>
            </div>
        </template>
    </el-dialog>



</template>



<script setup>
import { ref, onMounted, reactive } from 'vue'
import api from './api.js'
import PaginationBar from '@/components/PaginationBar.vue';
import { ElMessage } from "element-plus";
import {Upload} from "@element-plus/icons-vue";
import { getOrganizationsData } from '@/api/api';
import {listToTree} from "@/api/api";

const tableData = ref([]);

const addVisiable = ref(false)
let totalRecords = 0
let currentPage = 1
let pageSize = 10

const addFormRef = ref()
const uploadRef = ref()
const formRules = ref({
    version: [{ required: true, message: '请填写版本号' }],
    desc: [{ required: true, message: '请填写描述' }],
    file: [{ required: true, message: '请上传文件' }],
    green_file: [{ required: true, message: '请上传文件' }]
})

// 组织选项数据
const organizationOptions = ref([]);

// 获取组织列表的函数
async function fetchOrganizationOptions() {
    try {
        const response = await getOrganizationsData();
        if ( response?.data) {
            const treeData = listToTree(response.data);
            console.log('组织列表原始数据:', response.data);
            console.log('转换后的树形数据:', treeData);
            const transformedData = transformOrganizationsData(treeData);
            console.log('最终组织选项数据:', transformedData);
            organizationOptions.value = transformedData;
        } else {
            ElMessage.error('获取组织列表失败');
            // 使用模拟数据作为备选
            organizationOptions.value = [
                { label: '组织1', value: 1, children: [] },
                { label: '组织2', value: 2, children: [] },
                { label: '组织3', value: 3, children: [] },
                { label: '组织4', value: 4, children: [] },
                { label: '组织5', value: 5, children: [] }
            ];
        }
    } catch (error) {
        console.error('获取组织列表错误:', error);
        ElMessage.error('获取组织列表失败');
        // 使用模拟数据作为备选
        organizationOptions.value = [
            { label: '组织1', value: 1, children: [] },
            { label: '组织2', value: 2, children: [] },
            { label: '组织3', value: 3, children: [] },
            { label: '组织4', value: 4, children: [] },
            { label: '组织5', value: 5, children: [] }
        ];
    }
}

// 转换组织数据为树形选择器需要的格式
function transformOrganizationsData(treeData) {
    return treeData.map(item => ({
        label: item.name || item.label,
        value: item.id || item.value,
        children: item.children ? transformOrganizationsData(item.children) : []
    }));
}

// 在组件挂载时获取组织列表和数据
onMounted(() => {
    getData();
    // 获取组织列表数据
    fetchOrganizationOptions();
});

let addForm = reactive({
    version: '',
    file: '',
    file_name: '',
    desc: '',
    status: 0,
    green_file: '',
    exclude_organization_ids: []
})

const uploadUrl = process.env.VUE_APP_API_URL + '/api/common/upload'
const uploadHeader = { Authorization: 'Bearer ' + localStorage.getItem('token') }

function showAdd() {
    addVisiable.value = true
}

function handleClose() {
    resetForm()
    addVisiable.value = false;
}
function itemDelete(row) {
    api.delete(row.id).then(() => {
        getData()
    })
}

function getData() {
    api.index({
        page: currentPage,
        per_page: pageSize
    }).then(res => {
        tableData.value = res.data
        totalRecords = res.meta.total
    })
}

function handlePageChange(current) {
    currentPage = current
    getData()
}
function handlePageSizeChange(size) {
    pageSize = size
    getData()
}

function uploadSuccess(res) {
    addForm.file = res.key
    addForm.file_name = res.fileName
}
function uploadGreenSuccess(res) {
    addForm.green_file = res.key
}

async function add() {
    addFormRef.value.validate((valid) => {
        if (valid) {
            // 创建提交数据的副本，避免直接修改原始表单数据
            const submitData = { ...addForm };
            
            // 将exclude_organization_ids数组转换为逗号分隔的字符串，使用空格字符串代替空字符串
            if (Array.isArray(submitData.exclude_organization_ids)) {
                submitData.exclude_organization_ids = submitData.exclude_organization_ids.join(',') || '-';
            } else {
                submitData.exclude_organization_ids = '-';
            }
            
            api.add(submitData).then(res => {
                if (res?.code !== 0) {
                    ElMessage.error(res?.message | 'add error')
                    return
                }
                addVisiable.value = false
                currentPage = 1
                getData()
                resetForm()
            })
        }
    })



}

function changeStatus(row) {
    api.update(
        row.id,
        { status: row.status ? 0 : 1 }
    ).then(res => {
        if (res?.code !== 0) {
            ElMessage.error(res?.message | '更新失败')
            return
        }
        getData()
    })
}

function resetForm() {
    addFormRef.value?.resetFields()
    uploadRef.value?.clearFiles()
    // 重置排除组织字段
    addForm.exclude_organization_ids = []
}
function handleFileRemove() {
    addForm.file = ''
    addForm.file_name = ''
}
function handleGreenFileRemove() {
    addForm.green_file = ''
}


</script>
